import React, {
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';
import TPs from './tp';

function EditorRenderer({
  getControl,
  data,
  dataSetter,
  currentUser,
  fields,
}) {
  const onWarehouseChange = useCallback(
    (e, newRecs) => dataSetter({ grk_warehouse_set: newRecs }),
    [dataSetter],
  );
  const currentOrg = useMemo(
    () => (currentUser.is_superuser ? data.org && (data.org.id || null) : currentUser.org.id),
    [currentUser.is_superuser, currentUser.org.id, data.org],
  );
  const orgFilter = useMemo(
    () => ({
      org: currentOrg,
    }),
    [currentOrg],
  );
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          {getControl('account', { filter: orgFilter })}
        </Grid>
        <Grid item xs={6}>
          {getControl('date')}
        </Grid>
        {currentUser.is_superuser && (
          <>
            <Grid item xs={6}>
              {getControl('budgetary_institution', { filter: orgFilter })}
            </Grid>
            <Grid item xs={6}>
              {getControl('org')}
            </Grid>
          </>
        )}
      </Grid>
      <TPs.GeneralTP
        data={data.grk_warehouse_set}
        options={fields.grk_warehouse_set}
        onChange={onWarehouseChange}
        currentOrg={currentOrg}
      />
    </>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    grk_warehouse_set: PropTypes.arrayOf(PropTypes.shape({})),
    org: PropTypes.shape({
      id: PropTypes.number,
    }),
  }).isRequired,
  dataSetter: PropTypes.func.isRequired,
  currentUser: PropTypes.shape().isRequired,
  fields: PropTypes.shape({
    grk_warehouse_set: PropTypes.shape({}),
  }).isRequired,
};
const CP = CommandPanels.docCommandPanel();

export default withBaseEditor(EditorRenderer, '/api/document/grksubscriptions/', CP);
